import { render, staticRenderFns } from "./DataLabelList.vue?vue&type=template&id=8e871b58&"
import script from "./DataLabelList.vue?vue&type=script&lang=ts&"
export * from "./DataLabelList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports